import type { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Grid } from '@mui/material';

export type SplitScreenLayoutProps = PropsWithChildren<{
    logoTo: string;
    logoSrc: string;
    logoAlt: string;
    appName: string;
    subtitle: string;
}>;

export function SplitScreenLayout({
    children,
    logoTo,
    logoSrc,
    logoAlt,
    appName,
    subtitle,
}: SplitScreenLayoutProps) {
    return (
        <Box
            component='main'
            sx={{
                display: 'flex',
                flex: '1 1 auto',
                maxWidth: '100%',
                minHeight: '100vh',
            }}
        >
            <Grid container sx={{ flex: '1 1 auto' }}>
                <Grid
                    xs={12}
                    lg={6}
                    sx={{
                        backgroundColor: 'background.paper',
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                    }}
                >
                    <Box
                        component='header'
                        sx={{
                            left: 0,
                            p: 3,
                            position: 'fixed',
                            top: 0,
                            width: '100%',
                        }}
                    >
                        <Box
                            component={Link}
                            to={logoTo}
                            sx={{
                                display: 'flex',
                                height: 64,
                                width: 64,
                            }}
                        >
                            <img
                                src={logoSrc}
                                alt={logoAlt}
                                style={{ width: 64, height: 64 }}
                            />
                        </Box>
                    </Box>
                    {children}
                </Grid>
                <Grid
                    xs={12}
                    lg={6}
                    sx={{
                        alignItems: 'center',
                        background:
                            'radial-gradient(50% 50% at 50% 50%, #122647 0%, #090E23 100%)',
                        color: 'white',
                        display: 'flex',
                        justifyContent: 'center',
                        '& img': { maxWidth: '100%' },
                    }}
                >
                    <Box sx={{ p: 3 }}>
                        <Typography
                            align='center'
                            color='inherit'
                            sx={{
                                fontSize: '24px',
                                lineHeight: '32px',
                                mb: 1,
                            }}
                            variant='h1'
                        >
                            Willkommen bei{' '}
                            <Box component='span' sx={{ color: '#15B79E' }}>
                                {appName}
                            </Box>
                        </Typography>
                        <Typography
                            align='center'
                            sx={{ mb: 3 }}
                            variant='subtitle1'
                        >
                            {subtitle}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
